import { render, staticRenderFns } from "./edit-fire-policy-form.vue?vue&type=template&id=8588b856&scoped=true&"
import script from "./edit-fire-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-fire-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8588b856",
  null
  
)

export default component.exports